export default __webpack_public_path__ + "static/hero-illustration-258229cb41805d990ecb67f07cb622ef.svg";